import { createUseStyles } from 'react-jss';


import colors from "../../../utils/colors";

var styles = {
  userAccountDropdown: {
    width: '100%'
  },
  userDropdownOption: function userDropdownOption(_ref) {var customMainColor = _ref.customMainColor;return {
      backgroundColor: customMainColor || colors.neutral[900],
      position: 'relative',
      '&:after': {
        content: '" "',
        display: 'block',
        backgroundColor: colors.neutral.white,
        width: '90%',
        height: '0.1rem',
        position: 'absolute',
        bottom: 0,
        left: '5%',
        zIndex: '1'
      },
      '&:first-of-type': {
        borderRadius: '6px 6px 0px 0px'
      },
      '&:last-of-type': {
        borderRadius: '0px 0px 6px 6px',
        '&:after': {
          display: 'none'
        }
      }
    };},
  userDropdownLink: {
    color: colors.neutral.white,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '1.2rem 0rem',
    margin: '0rem 1.2rem'
  },
  userDropdownIcon: {
    width: '3.6rem',
    height: '3.6rem'
  },
  userDropdownLinkText: {
    marginLeft: '1.5rem',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 700
    }
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map